import React from 'react';
import { IconWrapper } from './styled';

const Icon = ({ children }) => {
  return <IconWrapper>{children}</IconWrapper>;
};

export default Icon;
